<template>
  <div
    class="chatbot-textarea-wrapper bg-white"
    :class="[$attrs.class, $attrs.disabled ? 'disabled' : '']"
    @keyup.enter.exact="onSend()"
    @keydown.enter.exact="onSend()">
    <label
      class="input-sizer stacked"
      for="message-input">
      <textarea
        ref="target"
        v-bind="$attrs"
        v-model="inputValue"
        oninput="this.parentNode.dataset.value = this.value"
        rows="1"
        aria-label="message-input"/>
    </label>
    <PlainButton
      v-if="!$attrs.disabled"
      class="send-button align-self-end"
      @click="onSend()">
      <SvgSend
        width="32"
        height="32"/>
    </PlainButton>
    <SvgSparkle
      v-else
      class="sparkle-spin m-sm text-teal"
      width="32"
      height="32"/>
  </div>
</template>

<script setup>
import { shallowRef, watch } from 'vue'
import { storeToRefs } from 'pinia'
import PlainButton from '@/components/global/sequin/PlainButton.vue'
import SvgSend from '@/components/global/svg/SvgSend.vue'
import SvgSparkle from '@/components/global/svg/SvgSparkle.vue'
import { useFocus } from '@vueuse/core'
import { useStylingChatbotStore } from '@/stores/stylingChatbot'

const target = shallowRef()
const { focused } = useFocus(target)
const { allowScroll } = storeToRefs(useStylingChatbotStore())

watch(focused, (focused) => {
  if (focused) {
    allowScroll.value = false
  }
})

defineOptions({
  compatConfig: {
    COMPONENT_V_MODEL: false
  }
})

const inputValue = defineModel({
  type: String,
  default: ''
})

defineProps({
  label: { type: String, required: true },
})

const emit = defineEmits(['send-message'])

function onSend() {
  const label = document.querySelector('.input-sizer')
  if (label) {
    label.dataset.value = ''
  }
  emit('send-message')
}
</script>


<style lang="scss" scoped>
.chatbot-textarea-wrapper {
  display: flex;
}
.chatbot-textarea-wrapper.disabled {
  opacity: 0.75;
  pointer-events: none;
}
.input-sizer {
  display: inline-grid;
  vertical-align: top;
  align-items: center;
  position: relative;
  padding: .25em .5em;
  flex: 1;

  &.stacked {
    padding: .5em;
    align-items: stretch;

    &::after,
    input,
    textarea {
      grid-area: 2 / 1;
    }
  }

  &::after,
  input,
  textarea {
    grid-area: 1 / 2;
    padding: $spacing-xs;
    margin: 0;
    resize: none;
    background: none;
    appearance: none;
    border: none;
    max-height: 150px;
  }

  span {
    padding: $spacing-xs;
  }

  &::after {
    content: attr(data-value) ' ';
    visibility: hidden;
    white-space: pre-wrap;
  }

  &:focus-within {

    textarea:focus,
    input:focus {
      outline: none;
    }
  }
}

.send-button {
  margin: 0px 8px 10px 0;
  padding: 0;
}

.sparkle-spin {
  animation: sparkle-spin 3s linear infinite;
}

@keyframes sparkle-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
